<elcia-title [title]="'app.directory' | translate" [iconType]="'users'"/>
<elcia-tabs [items]="items"/>
<router-outlet></router-outlet>
